import { render, staticRenderFns } from "./EditLoan.vue?vue&type=template&id=658985e4&scoped=true"
import script from "./EditLoan.vue?vue&type=script&lang=js"
export * from "./EditLoan.vue?vue&type=script&lang=js"
import style0 from "./EditLoan.vue?vue&type=style&index=0&id=658985e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658985e4",
  null
  
)

export default component.exports